'use client';
import { DashboardErrorPage } from '@/src/app/_components/error-page/error-page';

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  console.debug('Root layout error');
  return <DashboardErrorPage title={error.message} button={{ text: 'Try again', onClick: reset }} />;
}
